import { Pipe, PipeTransform } from '@angular/core';
//import moment from 'moment';

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CASTreeNodesPipe
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Pipe({
    name: 'CASTreeNodesPipe',
    pure: false                 //Having a stateful pipe causes it to be executed each time the source changes
})

export class CASTreeNodesPipe implements PipeTransform {

    //==================================
    // transform
    //==================================
    // Calls on the passed in node to transform itself and its children into a flattened array.
    transform(rootNode) {

        let flatList = rootNode.transformFlatten();
        return flatList;

        //console.log("[CASTreeNodesPipe(pipe):transform()] rootNode:", rootNode);
        //console.log("[CASTreeNodesPipe(pipe):transform()] flatList:", flatList);
    }

}